import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
	setTomorrowData,
	resetAllEditsTomorrow
} from "../../features/schedule/tomorrowSlice"
import useLogging from "../useLogging"
import useScheduleForTomorrow from "./useScheduleForTomorrow"

const useFetchSchedulesTomorrow = (componentName = "default") => {
	const dispatch = useDispatch()
	const logging = useLogging()
	const {
		data: scheduleData,
		isLoading,
		error,
		refetch: refetchSchedule
	} = useScheduleForTomorrow(componentName)

	const isEditing = useSelector(state => state.schedule.isEditing)

	const editedPatients = useSelector(state => state.tomorrow.editedPatients)
	const editedNurses = useSelector(state => state.tomorrow.editedNurses)

	useEffect(() => {
		logging.info("in use effect for tomorrow's schedule")
		if (!scheduleData) {
			return
		}

		if (isEditing) {
			return
		}

		dispatch(setTomorrowData(scheduleData))

		//If the editedPatients or editedNurses are not set, set them
		if (!editedPatients.length || !editedNurses.length) {
			dispatch(resetAllEditsTomorrow())
		}
		// Only re-run when scheduleData arrives. isEditing / edited* lengths are
		// guards consulted at that moment — adding them as deps would clobber
		// in-progress tomorrow-day edits whenever the user toggles edit mode.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [scheduleData])

	return { isLoading, error, refetch: refetchSchedule }
}

export default useFetchSchedulesTomorrow
